/** US state / territory abbreviations → extra search terms for venueCity strings like "Miami, FL". */
const US_STATE_TERMS = {
  al: 'alabama',
  ak: 'alaska',
  az: 'arizona',
  ar: 'arkansas',
  ca: 'california',
  co: 'colorado',
  ct: 'connecticut',
  de: 'delaware',
  dc: 'district of columbia washington dc',
  fl: 'florida',
  ga: 'georgia',
  hi: 'hawaii',
  id: 'idaho',
  il: 'illinois',
  in: 'indiana',
  ia: 'iowa',
  ks: 'kansas',
  ky: 'kentucky',
  la: 'louisiana',
  me: 'maine',
  md: 'maryland',
  ma: 'massachusetts',
  mi: 'michigan',
  mn: 'minnesota',
  ms: 'mississippi',
  mo: 'missouri',
  mt: 'montana',
  ne: 'nebraska',
  nv: 'nevada',
  nh: 'new hampshire',
  nj: 'new jersey',
  nm: 'new mexico',
  ny: 'new york',
  nc: 'north carolina',
  nd: 'north dakota',
  oh: 'ohio',
  ok: 'oklahoma',
  or: 'oregon',
  pa: 'pennsylvania',
  ri: 'rhode island',
  sc: 'south carolina',
  sd: 'south dakota',
  tn: 'tennessee',
  tx: 'texas',
  ut: 'utah',
  vt: 'vermont',
  va: 'virginia',
  wa: 'washington',
  wv: 'west virginia',
  wi: 'wisconsin',
  wy: 'wyoming'
};

export function getExperienceCountry(exp) {
  if (exp?.locationCountry) return exp.locationCountry;
  if (exp?.venueCountry === 'US') return 'United States';
  return exp?.venueCountry || '';
}

export function getExperienceCity(exp) {
  if (exp?.locationCity) return exp.locationCity;
  if (exp?.venueCity) return exp.venueCity.split(',')[0]?.trim() || '';
  if (!exp?.duration) return '';
  const [cityPart] = exp.duration.split(',').map((part) => part.trim());
  return cityPart?.replace(/^Superblue\s+/i, '') || '';
}

/** All location text searchable for a single city / state / country query. */
export function getExperienceLocationHaystack(exp) {
  const parts = [
    exp?.locationCity,
    exp?.locationCountry,
    exp?.venueCity,
    exp?.venueAddress,
    exp?.venueName,
    exp?.venueCountry
  ].filter(Boolean);

  let text = parts.join(' ').toLowerCase();

  if (exp?.venueCountry === 'US' || /united states/i.test(exp?.locationCountry || '')) {
    text += ' united states us usa';
  }

  const venueCity = String(exp?.venueCity || '');
  const stateMatch = venueCity.match(/,\s*([A-Za-z]{2})\b/);
  if (stateMatch) {
    const abbr = stateMatch[1].toLowerCase();
    const stateTerms = US_STATE_TERMS[abbr];
    if (stateTerms) text += ` ${stateTerms} ${abbr}`;
  }

  return text.replace(/\s+/g, ' ').trim();
}

/** Match one search string against city, state, or country fields. */
export function matchesLocationQuery(exp, query) {
  const needle = query.trim().toLowerCase();
  if (!needle) return true;

  const haystack = getExperienceLocationHaystack(exp);
  if (!haystack) return false;
  if (haystack.includes(needle)) return true;

  const tokens = needle.split(/[\s,]+/).filter(Boolean);
  if (tokens.length > 1) {
    return tokens.every((token) => haystack.includes(token));
  }

  return false;
}

/** @deprecated use matchesLocationQuery */
export function matchesLocationSearch(exp, countryQuery, cityQuery, stateCities = null) {
  const combined = [countryQuery, cityQuery].filter((s) => s?.trim()).join(' ');
  if (stateCities?.length && cityQuery?.trim()) {
    return stateCities.some((name) => matchesLocationQuery(exp, name)) || matchesLocationQuery(exp, combined);
  }
  return matchesLocationQuery(exp, combined);
}
